import { Flex, Text } from '@chakra-ui/react';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Banner, Button, ButtonText, FileUpload } from '@morressier/alembic';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import { DropzoneOptions, ErrorCode } from 'react-dropzone';
import { FormProvider, useForm } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';

const OwnCopyrightForm = () => {
  const methods = useForm();
  const {
    handleSubmit,
    register,
    resetField,
    formState: { errors },
    setValue,
    setError
  } = methods;

  const onDrop: DropzoneOptions['onDrop'] = (
    acceptedFiles: (File | ISubmissionFile)[]
  ) => {
    const accepted = acceptedFiles[0];
    resetField('fileSet.Manuscript');

    if (accepted) {
      setValue('fileSet.Manuscript', accepted as ISubmissionFile);
    }
  };

  const onDropRejected: DropzoneOptions['onDropRejected'] = rejectedFiles => {
    if (rejectedFiles[0]) {
      const rejectedFileError = rejectedFiles[0].errors[0];
      if (rejectedFileError?.code === 'file-invalid-type') {
        setError('fileSet.Manuscript', {
          type: rejectedFileError.code,
          message: 'File format selected not supported, upload PDF file only.'
        });
      }
      if (rejectedFileError?.code === ErrorCode.FileTooLarge) {
        setError('fileSet.Manuscript', {
          type: 'upload-error',
          message: `File is larger than 25MB.`
        });
      }
      if (rejectedFileError?.code === ErrorCode.TooManyFiles) {
        setError('fileSet.Manuscript', {
          type: rejectedFileError.code,
          message: rejectedFileError.message
        });
      }
    }
  };
  const submit = () => {};
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submit)}>
        <Flex flexDirection="column" gap={8}>
          <Flex
            height="100vh"
            width="100vw"
            backgroundColor="surfaceSecondaryFill"
            justifyContent="center"
          >
            <Flex flexDirection="column" gap={8} width={'60%'} mt={20}>
              <Flex flexDirection="column" gap={8}>
                <Flex flexDirection="column" gap={2}>
                  <Text textStyle="headingTitle">
                    Copyright and Publication Agreement
                  </Text>
                  <Text textStyle="textBody">
                    As a co-author in this submission, we kindly ask you to
                    download and upload the required agreement for the
                    publication of your submission. This is a mandatory step:
                    this submission cannot be published until all authors
                    provide an agreement.
                  </Text>
                </Flex>
                <Banner
                  heading=""
                  content={
                    <Flex flexDirection="row">
                      <Text textStyle="headingItem">
                        Download The {'BNJ'} Agreement First:{' '}
                      </Text>
                      <ButtonText variant="primary">
                        Download Agreement
                      </ButtonText>
                    </Flex>
                  }
                  customIcon={<FontAwesomeIcon icon={faTriangleExclamation} />}
                  variant="attention"
                />
              </Flex>
              {
                <Flex gap={2} flexDirection="column">
                  <FieldLabel
                    label={'Upload Copyright and Publication Agreement'}
                    subText={`Please upload a signed copyright form to proceed with publication.`}
                    isRequired={true}
                  />
                  <Flex flexDirection="column" gap={2}>
                    <FileUpload
                      {...register('fileSet.Manuscript')}
                      uploadButtonText="Select file"
                      multiple={false}
                      onDrop={onDrop}
                      onDropRejected={onDropRejected}
                      maxFiles={1}
                      maxSize={25 * 1000000}
                      isInvalid={Boolean(errors)}
                      // accept={allowedFileTypePdf}
                    />
                    <Text>Accepted file formats: PDF, DOC, DOCX.</Text>
                  </Flex>
                </Flex>
              }
              <Flex width="100%" justifyContent="flex-start" gap={4}>
                <Button variant="primary" type="submit">
                  Submit Agreement
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </form>
    </FormProvider>
  );
};

export default OwnCopyrightForm;
